import copyTextToClipBoard from "../utilities/copyTextToClipBoard";
import { useGetText, UseGetText } from "./useGetText";

export interface UseCopyToClipBoard<T extends HTMLElement> extends UseGetText<T> {
    copyToClipBoard: (() => void)
}

export function useCopyToClipBoard<T extends HTMLElement>(): UseCopyToClipBoard<T> {
    const props = useGetText<T>();

    const copyToClipBoard = () => {
        const text = props.getText()
        copyTextToClipBoard(text)
    }

    return { copyToClipBoard, ...props }

}

export default useCopyToClipBoard;
